import styled from 'styled-components'
import DayPicker from 'react-day-picker'

import rem from '../../../../styles/tools/rem'

import { txt14OpenSans, txt16OpenSans, title16Galano } from '../../../../styles/settings/types'

import { darkSlateBlue, red } from '../../../../styles/settings/colors'

export const RangeInput = styled.input`
  border: none;
  border-bottom: 2px solid ${({ invalid }) => (invalid ? red : darkSlateBlue)};
  background-color: #e2e1eb;
  padding: ${rem('16px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: ${rem('360px')};
`

export const RangeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledCalendarPicker = styled(DayPicker)`
  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #e2e1eb !important;
    color: ${darkSlateBlue};
  }
  .DayPicker-Day {
    border-radius: 0 !important;
    color: ${darkSlateBlue};
    ${txt14OpenSans};
  }
  .DayPicker-Caption {
    ${title16Galano};
    color: ${darkSlateBlue};
    text-align: center;
  }
  .DayPicker-NavButton--next {
    right: 0;
  }
  .DayPicker-NavButton--prev {
    left: 0;
  }
  .DayPicker-Day--start,
  .DayPicker-Day--end {
    outline: none;
    padding: 0 !important;
  }
  .DayPicker-Day--start {
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 50%, rgba(226, 225, 235, 1) 50%);
  }
  .DayPicker-Day--end {
    background: linear-gradient(90deg, rgba(226, 225, 235, 1) 50%, rgba(255, 255, 255, 1) 50%);
  }
  .DayPicker-Day--start div,
  .DayPicker-Day--end div {
    background-color: ${darkSlateBlue};
    color: white;
    outline: none;
    border-radius: 60px !important;
    padding: 0.5em;
  }
  .DayPicker-Weekday abbr {
    ${txt14OpenSans};
  }
`

export const Error = styled.span`
  color: ${red};
  display: inline-block;
  font-family: OpenSans;
  font-size: ${rem('14px')};
  letter-spacing: ${rem('-0.3px')};
  margin-top: ${rem('10px')};
`

export const Day = styled.div`
  color: ${darkSlateBlue};
`



// WEBPACK FOOTER //
// ./src/app/modules/FilterByPeriod/CalendarFilter/styles.js